const Profile = {
  EN: {
    profilePopover: {
      profile: 'Profile',
      logout: 'Logout',
    },
    profilePage: {
      header: 'PROFILE',
      menuTitle: 'PROFILE SETTINGS',
      menu: {
        1: 'Personal info',
        2: 'Change password',
        3: 'Change passcode',
        4: 'Theme settings',
        5: 'Delete Account',
        6: 'Danger Zone',
        7: 'Change FaceId',
        8: 'Add Card',
        9: 'Add License-plate',
      },
      personalInfo: {
        title: 'Update your personal information',
        firstName: 'First name',
        lastName: 'Last name',
        profileName: 'Profile name',
        email: 'Email',
        phone: 'Phone Number',
      },
      changePassword: {
        title: 'Change your account password',
      },
      changeFaceId: {
        title: 'Change your faceId',
        accuracy: 'Accuracy percentage',
      },
      changeTheme: {
        title: 'Change your account theme',
      },
      emailSettings: {
        title: 'Change your email settings',
      },
      deleteAccount: {
        title: 'Delete your user account',
        warning: 'Unexpected bad things will happen if you don`t read this!',
        field: { email: 'Please enter your email', phone: 'Please enter your phone' },
        content: {
          1: 'Are you sure you want to delete user?',
          2: 'Your account will be deleted resulting in the loss of all data.',
          3: 'You will not be able to recover.',
          4: 'To confirm this action, please type',
        },
      },
    },
    title: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      status: 'Status',
    },
    placeholder: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      status: 'Status',
    },
    notification: {
      verifyFace: 'Validated facial',
      rejectFace: 'This facial is unacceptable.',
    },
  },
  TH: {
    profilePopover: {
      profile: 'บัญชีของฉัน',
      logout: 'ออกจากระบบ',
    },
    profilePage: {
      header: 'บัญชีของฉัน',
      menuTitle: 'ตั้งค่าบัญชีของฉัน',
      menu: {
        1: 'ข้อมูลส่วนตัว',
        2: 'เปลี่ยนรหัสผ่าน',
        3: 'เปลี่ยนรหัสลับ',
        4: 'ตั้งค่าธีม',
        5: 'ลบบัญชี',
        6: 'โซนอันตราย',
        7: 'เปลี่ยน FaceId',
        8: 'เพิ่มบัตร',
        9: 'เพิ่มทะเบียนรถ',
      },
      personalInfo: {
        title: 'อัปเดตข้อมูลส่วนตัวของคุณ',
        firstName: 'ชื่อ',
        lastName: 'นามสกุล',
        profileName: 'ชื่อบัญชีผู้ใช้',
        email: 'อีเมล',
        phone: 'หมายเลขโทรศัพท์',
      },
      changePassword: {
        title: 'เปลี่ยนรหัสผ่านของบัญชีคุณ',
      },
      changeFaceId: {
        title: 'เปลี่ยน FaceId',
        accuracy: 'เปอร์เซ็นต์ความแม่นยำ',
      },
      changeTheme: {
        title: 'เปลี่ยนธีมของบัญชีคุณ',
      },
      emailSettings: {
        title: 'เปลี่ยนการตั้งค่าอีเมลของคุณ',
      },
      deleteAccount: {
        title: 'ลบบัญชีผู้ใช้ของคุณ',
        warning: 'สิ่งที่ไม่คาดคิดจะเกิดขึ้นหากคุณไม่อ่านสิ่งนี้!',
        field: { email: 'กรุณาใส่อีเมล', phone: 'กรุณาใส่หมายเลขโทรศัพท์' },
        content: {
          1: 'คุณแน่ใจหรือว่าต้องการลบผู้ใช้?',
          2: 'บัญชีของคุณจะถูกลบ ทำให้ข้อมูลทั้งหมดสูญหาย',
          3: 'คุณจะไม่สามารถกู้คืนได้',
          4: 'เพื่อยืนยันการกระทำนี้ กรุณาพิมพ์',
        },
      },
    },
    title: {
      firstName: 'ชื่อ',
      lastName: 'นามสกุล',
      email: 'อีเมล',
      status: 'สถานะ',
    },
    placeholder: {
      firstName: 'ชื่อ',
      lastName: 'นามสกุล',
      email: 'อีเมล',
      status: 'สถานะ',
    },
    notification: {
      verifyFace: 'ยืนยันใบหน้า',
      rejectFace: 'ไม่สามารถยืนยันใบหน้าได้ กรุณาลองอีกครั้ง',
    },
  },
};

export default Profile;
